/**
 * VAT Switcher - displaying prices with VAT and without VAT
 * Set cookie for tax preference
 *
 * @package
 */

export default class QalaVatSwitcher {
	init = () => {
		wp.hooks.doAction( 'qvs_before_init' );

		// Call function on QEF pages
		wp.hooks.addAction(
			'qalaElasticCore.action.onResult.results',
			'qala-vat-switcher',
			this.ensureResultsLoad,
			600
		);

		/* Use jQuery for WC checkout hook */
		jQuery( document ).on( 'updated_checkout', () => {
			this.checkCookie();
			this.setupToggleListener();
		} );

		/* Use jQuery for WC cart updated hook */
		jQuery( document ).on( 'updated_wc_div', () => {
			this.checkCookie();
			this.setupToggleListener();
		} );

		/* Need to use jQuery for compatibility with Woo Composite Products. Documentation for composite_data - https://woo.com/document/composite-products/composite-products-js-api-reference/#api_filters */
		this.compositeProductsIntegrationHooks();

		// Call function on product pages and shop.
		window.addEventListener( 'DOMContentLoaded', () => {
			this.checkCookie();
			this.setupToggleListener();
		} );

		// Run actions after setup.
		wp.hooks.doAction( 'qvs_after_init' );

		// Setup a global JS function that can be used to check the cookie value.
		window.QalaVatSwitcher.isPriceIncVat = () => {
			return this.checkCookie() === '1';
		};

		// Once variation selected, remove price range.
		jQuery( 'body' ).on( 'found_variation', () => {
			const priceRangesShowing = document.querySelectorAll( '.product-wrap .price-range.show-price' );
			priceRangesShowing.forEach( priceRangeShowing => {
				priceRangeShowing.classList.remove( 'show-price' );
			} );
			// Update variable total price.
			setTimeout( () => {
				this.checkCookie();
			}, 300 );
		} );

		// Target variation select dropdowns.
		const variationDropdowns = document.querySelectorAll( '.product-wrap select[data-attribute_name]' );

		variationDropdowns.forEach( variationDropdown => {
			// When the dropdown changes, show the range if the value (and therefore, price) is empty.
			variationDropdown.addEventListener(
				'change',
				e => {
					const eventTarget = e.target;

					// Exit early if we don't need to do anything.
					if ( eventTarget.value !== '' ) {
						return;
					}

					// If we select '' from our variation dropdown, show the range again.
					const priceRangesHidden = document.querySelectorAll( '.summary-inner-wrapper .price-range' );
					priceRangesHidden.forEach( priceRangeHidden => {
						priceRangeHidden.classList.add( 'show-price' );
					} );
				}
			);
		} );
	};

	/**
	 * Delay function until after EF results render
	 *
	 */
	ensureResultsLoad = () => {
		setTimeout( () => {
			this.checkCookie();
		}, 100 );
	};

	/**
	 * Switch price based on toggle
	 *
	 * @param { boolean } sliderValue
	 */
	setVATEXclOrIncl = sliderValue => {
		let productPrices = document.querySelectorAll( '.price' );

		let priceRanges = document.querySelectorAll( '.price-range' );

		// Check if we are on variable product page.
		const productVariable = document.querySelector( '.summary-inner-wrapper .price-range' );

		if ( document.querySelector( 'body.woocommerce-shop' ) ) {
			priceRanges = document.querySelectorAll( '.price .price-range' );
		}

		// Check that variations have not been already selected on product page by checking price element.
		const checkPrice = document.querySelector( '.summary-inner-wrapper .price > .woocommerce-Price-amount' );

		// Show price ranges if variations have not been selected
		let hidePriceRanges = 0;

		// Check if variations have been set on variable product page.
		if ( document.querySelector( 'body.single-product' ) && ( productVariable ) && checkPrice ) {
			hidePriceRanges = 1;
		}

		// Check for variable or grouped product price ranges.
		// Hide price range if variations already selected.
		if ( priceRanges && priceRanges.length > 0 && ! hidePriceRanges ) {
			[ ...priceRanges ].forEach( priceRange => {
				const priceRangeExVat = priceRange.parentNode.querySelector( '.price-range-ex-vat' );

				if ( priceRange === null || priceRangeExVat === null ) {
					return;
				}

				if ( Number( sliderValue ) === 1 ) {
					priceRangeExVat.classList.remove( 'show-price' );
					priceRange.classList.add( 'show-price' );
				} else {
					priceRange.classList.remove( 'show-price' );
					priceRangeExVat.classList.add( 'show-price' );
				}
			} );
		}

		// Extra selectors we want to attach ourselves to.
		const additionalSelectors = [
			'.woocommerce-grouped-product-list-item__price', // Grouped products.
			'.product-price', // Checkout prices.
			'.cart-subtotal', // Cart subtotals.
			'.product-subtotal', // Cart product subtotals.
			'.lowest-price-in-last-30-days__details', // Product Price History prices.
		];

		// Loop through our additional selectors and add them to the main array for processing.
		additionalSelectors.forEach( additionalSelector => {
			const additionalSelectorElements = document.querySelectorAll( additionalSelector );

			if ( additionalSelectorElements.length > 0 ) {
				productPrices = [
					...productPrices,
					...additionalSelectorElements,
				];
			}
		} );

		// Check if this is a composite product. This behaves differently to other product price types.
		const compositeProductPrices = document.querySelectorAll( '.composite_price' );

		if ( compositeProductPrices.length > 0 ) {
			this.updateCompositePrices( sliderValue, compositeProductPrices );
		}

		this.updatePrices( sliderValue, productPrices );
	};

	/**
	 * Update composite prices including sales prices.
	 *
	 * @param { boolean } sliderValue
	 * @param { Object }  productPrices
	 */
	updateCompositePrices = ( sliderValue, productPrices ) => {
		productPrices.forEach( productPrice => {
			if ( ! productPrice.childNodes.length ) {
				return;
			}

			const totalsPrice = ( Number( sliderValue ) === 1 ) ? this.totalsInclTax : this.totalsExclTax;
			const saleProduct = productPrice;

			if ( productPrice.contains( saleProduct ) ) {
				if ( ! saleProduct.querySelector( '.woocommerce-Price-amount.amount' ) ) {
					return;
				}

				const salePriceAmount = saleProduct.querySelector( '.woocommerce-Price-amount.amount' );

				this.switchPrice( salePriceAmount, totalsPrice );
			} else {
				if ( ! productPrice.querySelector( '.woocommerce-Price-amount.amount' ) ) {
					return;
				}
				const compositeProductPrice = productPrice.querySelector( '.woocommerce-Price-amount.amount' );

				this.switchPrice( compositeProductPrice, totalsPrice );
			}
		} );
	};

	/**
	 *
	 * Update prices and sales prices.
	 *
	 * @param { boolean } sliderValue
	 * @param { Object }  productPrices
	 */
	updatePrices = ( sliderValue, productPrices ) => {
		productPrices.forEach( productPrice => {
			const saleProduct = productPrice.querySelector( 'ins' );
			const originalPrice = productPrice.querySelector( 'del' );

			if ( productPrice.contains( saleProduct ) ) {
				const salePriceAmount = saleProduct.querySelector( '.woocommerce-Price-amount.amount' );
				if ( salePriceAmount.dataset.priceVariations ) {
					const priceVariations = JSON.parse( salePriceAmount.dataset.priceVariations );
					const salePrice = ( Number( sliderValue ) === 1 ) ? priceVariations.sale_price : priceVariations.sale_price_ex_vat;
					this.switchPrice( salePriceAmount, salePrice, priceVariations.currency, priceVariations.price_format );
				}
				const originalPriceAmount = originalPrice.querySelector( '.woocommerce-Price-amount.amount' );
				if ( originalPriceAmount.dataset.priceVariations ) {
					const priceVariations = JSON.parse( originalPriceAmount.dataset.priceVariations );
					const price = ( Number( sliderValue ) === 1 ) ? priceVariations.regular_price : priceVariations.regular_price_ex_vat;
					this.switchPrice( originalPriceAmount, price, priceVariations.currency, priceVariations.price_format );
				}
			} else {
				if ( ! productPrice.querySelector( '.woocommerce-Price-amount.amount' ) ) {
					return;
				}

				const regularProductPrice = productPrice.querySelector( '.woocommerce-Price-amount.amount' );

				if ( regularProductPrice.dataset.priceVariations ) {
					const priceVariations = JSON.parse( regularProductPrice.dataset.priceVariations );
					const price = ( Number( sliderValue ) === 1 ) ? priceVariations.regular_price : priceVariations.regular_price_ex_vat;

					this.switchPrice( regularProductPrice, price, priceVariations.currency, priceVariations.price_format );
				}
			}
		} );
	};

	/**
	 * Create a new price element for inserting into the DOM.
	 *
	 * @param {string} priceVal      The price to display as a string.
	 * @param {string} priceCurrency The string that represents the currency (£, $, kr etc.).
	 * @param {string} priceFormat   String that represents the format of the price.
	 *
	 * @return {Node} The constructed node element.
	 */
	createNewPrice = ( priceVal, priceCurrency, priceFormat = '%1$s%2$s' ) => {
		// Create the wrapper and text value.
		const priceEl = document.createElement( 'bdi' );
		const priceText = document.createTextNode( priceVal );

		// Create the currency span, give it the correct class.
		const currencyEl = document.createElement( 'span' );
		currencyEl.classList.add( 'woocommerce-Price-currencySymbol' );

		// Create the currency text and add it to the span.
		let currencyString = priceCurrency;

		// Uses a regex test as .includes( ' ' ) doesn't cover all types of whitespace.
		if ( /\s/.test( priceFormat ) === true ) {
			currencyString = priceFormat.startsWith( '%1$s' ) === true ? currencyString + ' ' : ' ' + currencyString;
		}

		const currencyText = document.createTextNode( currencyString );
		currencyEl.appendChild( currencyText );

		// Add the currency span before the price.
		if ( priceFormat.startsWith( '%1$s' ) === true ) {
			priceEl.appendChild( currencyEl );
		}

		priceEl.appendChild( priceText );

		// Add the currency span after the price.
		if ( priceFormat.endsWith( '%1$s' ) === true ) {
			priceEl.appendChild( currencyEl );
		}

		return priceEl;
	};

	/**
	 * Replace price in string.
	 *
	 * @param {Node}   elem
	 * @param {string} priceVal The price to display as a string.
	 */
	switchPrice = ( elem, priceVal ) => {
		if ( ! elem.innerHTML ) {
			return;
		}

		// Clear the element. Append a newly created replacement element.
		elem.innerHTML = '';
		elem.appendChild( this.createNewPrice(
			priceVal,
			window.QalaVatSwitcher.currency.symbol,
			window.QalaVatSwitcher.currency.format
		) );
	};

	/**
	 * Set VAT switcher cookie
	 *
	 * @param { string }  cname
	 * @param { boolean } cvalue
	 * @param { number }  exdays
	 */
	setCookie = ( cname, cvalue, exdays ) => {
		const d = new Date();
		d.setTime( d.getTime() + ( exdays * 24 * 60 * 60 * 1000 ) );
		const expires = 'expires=' + d.toUTCString();
		document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
	};

	/**
	 * Get cookies if set.
	 *
	 * @param { string } cname
	 * @return { string } Get cookie.
	 */
	getCookie = cname => {
		const name = cname + '=';
		const ca = document.cookie.split( ';' );
		for ( let i = 0; i < ca.length; i++ ) {
			let c = ca[ i ];
			while ( c.charAt( 0 ) === ' ' ) {
				c = c.substring( 1 );
			}
			if ( c.indexOf( name ) === 0 ) {
				return c.substring( name.length, c.length );
			}
		}
		return '';
	};

	/**
	 * Check if VAT Switcher cookie is set and change based on slider value, otherwise set as true.
	 *
	 * @return { void }
	 */
	checkCookie = () => {
		const vatinclexcl = this.getCookie( 'vatinclexcl' );

		if ( vatinclexcl !== '' ) {
			const sliders = document.querySelectorAll( '[name="vat-incl-excl"]' );
			// Check slider exists
			if ( ! sliders ) {
				return;
			}
			sliders.forEach( slider => {
				slider.checked = Number( vatinclexcl ) === 1 ? true : false;
			} );
			this.setVATEXclOrIncl( vatinclexcl );
		} else {
			this.setCookie( 'vatinclexcl', 1, 365 );
		}

		return vatinclexcl;
	};

	/**
	 * Check cookie setting and listen for changes.
	 *
	 */
	setupToggleListener = () => {
		this.checkCookie();
		const toggles = document.querySelectorAll( '.qala-vat-switcher-toggle' );

		// Check slider exists
		if ( ! toggles ) {
			return;
		}

		// Setup the listener for each toggle found.
		// Ideally its just one, but we cannot be sure.
		toggles.forEach( theToggle => {
			theToggle.addEventListener( 'change', this.toggleChanged );
		} );
	};

	/**
	 * Update other toggles when another one is checked.
	 *
	 * @param {boolean} value the value of the changed toggle.
	 */
	updateToggles = value => {
		const toggles = document.querySelectorAll( '.qala-vat-switcher-toggle' );

		// Check toggles exist
		if ( ! toggles ) {
			return;
		}

		// make sure all toggles on the page are checked with the same value.
		toggles.forEach( theToggle => {
			theToggle.checked = Number( value ) === 1 ? true : false;
		} );
	};

	/**
	 * A toggle was changed, lets make sure that is reflected!
	 *
	 * @param {Event} event the event from the change.
	 */
	toggleChanged = event => {
		const theToggle = event.target;
		const value = theToggle.checked ? 1 : 0;

		// You can perform actions based on the new value here
		this.updateToggles( value );
		this.setCookie( 'vatinclexcl', value, 365 );
		this.setVATEXclOrIncl( value );
	};

	/**
	 * Add hooks for composite products plugin.
	 *
	 * Need to use jQuery for compatibility with Woo Composite Products.
	 * Documentation for composite_data - https://woo.com/document/composite-products/composite-products-js-api-reference/#api_filters
	 */
	compositeProductsIntegrationHooks() {
		jQuery( '.composite_data' ).on(
			'wc-composite-initializing',
			( event, composite ) => {
				composite.filters.add_filter(
					'composite_totals',
					totals => {
						totals.price = this.checkCookie() === '1' ? totals.price_incl_tax : totals.price_excl_tax;
						totals.regular_price = totals.price;

						// Save values for switcher.
						this.totalsInclTax = totals.price_incl_tax;
						this.totalsExclTax = totals.price_excl_tax;

						return totals;
					},
					200,
					this
				);

				composite.filters.add_filter(
					'component_totals',
					totals => {
						totals.price = this.checkCookie() === '1' ? totals.price_incl_tax : totals.price_excl_tax;
						totals.regular_price = totals.price;

						return totals;
					},
					2,
					this
				);

				// Trigger a recalculation after the component options are rendered (i.e. after user selects any options for the composite product)
				composite.actions.add_action(
					'component_options_state_rendered',
					() => {
						// Need a timeout cause apparently the component options are not ready yet and
						// this is as "late" of a hook I could find here: https://woo.com/document/composite-products/composite-products-js-api-reference/#api_actions
						setTimeout( () => {
							this.checkCookie();
						}, 200 );
					},
					999
				);
			}
		);
	}
}
